var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTachometer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_288_10",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_288_10)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.05664 29.8617C6.81282 27.7072 6.20735 25.3256 6.20836 22.9598H0.781251C0.780469 26.2489 1.62391 29.5625 3.35617 32.5629C4.10211 33.8609 5.75899 34.3084 7.05703 33.5625C8.355 32.8166 8.80258 31.1596 8.05664 29.8617Z",
    fill: "#FFEAB7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7916 22.9598C33.7926 25.3256 33.1871 27.7072 31.9433 29.8617C31.1974 31.1597 31.6449 32.8166 32.9429 33.5625C34.241 34.3084 35.8978 33.8609 36.6438 32.5629C38.3761 29.5626 39.2195 26.2489 39.2187 22.9598H33.7916Z",
    fill: "#F4874C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32695 21.1563C6.56062 19.3809 7.14305 17.6485 8.06 16.0662L3.35023 13.347C2.08102 15.5505 1.27297 17.9695 0.945781 20.4545C0.836563 21.2842 0.781484 22.1212 0.78125 22.9598H6.20828C6.20852 22.3562 6.24828 21.7537 6.32695 21.1563Z",
    fill: "#FFD674"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34991 13.3471L8.0596 16.0663C8.65242 15.0431 9.38515 14.0828 10.2538 13.214C11.1264 12.3415 12.0868 11.6104 13.1067 11.0208L10.3837 6.30455C8.96109 7.12713 7.62132 8.14705 6.40413 9.36431C5.19476 10.5736 4.17491 11.9149 3.34991 13.3471Z",
    fill: "#FFD674"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3837 6.30444L13.1067 11.0207C15.2322 9.79178 17.6159 9.17733 19.9997 9.17733V3.73249C16.6744 3.73249 13.3491 4.58975 10.3837 6.30444Z",
    fill: "#FFBA4A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3.73241V9.17733C21.1458 9.17733 22.2916 9.31928 23.4087 9.60319L23.7263 9.68796C24.8215 9.99436 25.8863 10.4386 26.893 11.0207L29.6159 6.30436C26.6505 4.58975 23.3252 3.73241 20 3.73241Z",
    fill: "#FFBA4A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6156 6.30453L26.8926 11.0208C27.9126 11.6104 28.873 12.3415 29.7455 13.214C30.6142 14.0827 31.3469 15.0431 31.9397 16.0663L36.6494 13.3471C35.8245 11.9148 34.8046 10.5736 33.5952 9.3643C32.378 8.14703 31.0383 7.12711 29.6156 6.30453Z",
    fill: "#F99964"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6501 13.347L31.9404 16.0662C32.8573 17.6486 33.4397 19.3809 33.6734 21.1563C33.7521 21.7537 33.7918 22.3562 33.7921 22.9597H39.2192C39.2189 22.1212 39.1639 21.2842 39.0546 20.4544C38.7274 17.9694 37.9194 15.5506 36.6501 13.347Z",
    fill: "#F99964"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6011 24.4535L23.3954 25.0735L34.9002 26.9532L23.9957 22.8284L20.4008 21.4686C19.606 21.1679 18.7284 21.7405 18.5086 22.5611C18.2886 23.3818 18.7627 24.3165 19.6011 24.4535Z",
    fill: "#616473"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3954 25.0735L19.6011 24.4535C18.7626 24.3166 18.2886 23.3818 18.5085 22.5612C18.7284 21.7406 19.606 21.168 20.4008 21.4687L23.9958 22.8285C23.9635 21.8502 23.5742 20.8813 22.8274 20.1346C21.2664 18.5736 18.7355 18.5736 17.1744 20.1346C15.6135 21.6956 15.6135 24.2266 17.1744 25.7877C18.7355 27.3487 21.2664 27.3487 22.8274 25.7877C23.0479 25.5671 23.2372 25.3273 23.3954 25.0735Z",
    fill: "#E0CD9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6875 31.4234H15.3125V33.9234H24.6875V31.4234Z",
    fill: "#FFF4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88781 7.26516C12.2056 4.91016 16.103 3.7325 20 3.7325C24.9205 3.7325 29.8412 5.60977 33.5957 9.36422C36.6655 12.4341 38.5145 16.3542 39.0543 20.4545C39.592 24.5388 38.8178 28.7975 36.6439 32.5629C35.898 33.8609 34.2411 34.3084 32.9431 33.5625C31.6452 32.8166 31.1976 31.1596 31.9434 29.8616C33.5046 27.1577 34.0602 24.0956 33.6732 21.1563C33.2883 18.233 31.9582 15.4262 29.7459 13.2139C27.0549 10.5229 23.5275 9.17735 20 9.17735C16.4726 9.17735 12.9453 10.5229 10.2541 13.2139C8.04187 15.4262 6.71171 18.233 6.32695 21.1563C5.93999 24.0956 6.49546 27.1577 8.05656 29.8616C8.80249 31.1596 8.35499 32.8166 7.05695 33.5625C5.75898 34.3084 4.10203 33.8609 3.35609 32.5629C1.18226 28.7976 0.408119 24.5388 0.945775 20.4545C1.39507 17.0426 2.75078 13.7552 4.96203 10.9788M6.40445 9.36422C6.40703 9.36157 6.4096 9.35891 6.41226 9.35633",
    stroke: "#181920",
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3956 25.0736C23.2374 25.3273 23.0481 25.5672 22.8275 25.7876C21.2665 27.3487 18.7356 27.3487 17.1745 25.7876C15.6136 24.2266 15.6136 21.6957 17.1745 20.1347C18.7356 18.5736 21.2665 18.5736 22.8275 20.1347C23.5743 20.8814 23.9636 21.8501 23.9959 22.8285",
    stroke: "#181920",
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07704 22.9597H0.912903",
    stroke: "#181920",
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95227 16.0039L3.45898 13.4097",
    stroke: "#181920",
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.069 10.9547L10.4225 6.37081",
    stroke: "#181920",
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.05624V3.8539",
    stroke: "#181920",
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9532 10.9167L29.5558 6.409",
    stroke: "#181920",
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0216 16.0192L36.5679 13.3943",
    stroke: "#181920",
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8771 22.9597H39.1332",
    stroke: "#181920",
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3126 33.9234H24.6875V31.4234H15.3126V33.9234Z",
    stroke: "#181920",
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9002 26.9532L19.6011 24.4534C18.7627 24.3165 18.2887 23.3817 18.5085 22.5611L18.5086 22.5611C18.7284 21.7405 19.606 21.1679 20.4009 21.4686L34.9002 26.9532Z",
    stroke: "#181920",
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45258 22.9596H8.46438",
    stroke: "#181920",
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.228 12.9659L14.2339 12.9762",
    stroke: "#181920",
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7719 12.9675L25.766 12.9777",
    stroke: "#181920",
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5404 22.9625H31.5286",
    stroke: "#181920",
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.284 36.2671H17.2656M22.7345 36.2672H19.5286",
    stroke: "#181920",
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTachometer);
export default __webpack_public_path__ + "static/media/tachometer.db94781dc215f0db7a83877da700df1d.svg";
export { ForwardRef as ReactComponent };